import { useOutletContext } from 'react-router-dom';
import { useOpenModal } from '@rainbow-modules/hooks';
import CalendarWeekView from 'components/CalendarWeekView';
import { getCalendarsForAvailableSlot } from 'components/CalendarWeekView/helpers/getAvailabilityForWeekDay';
import ModalTitle from 'components/ModalTitle';
import { ViewContextType } from 'pages/Calendar/types';
import { ADD_RESCHEDULE_CALENDAR_EVENT, CALENDAR_EVENT_DETAILS } from '../../../../constants';
import getEventStartAtFromMinutes from '../Day/helpers/getEventStartAtFromMinutes';
import { Container } from '../Day/styled';

const CalendarViewWeek = () => {
    const {
        calendars,
        events,
        selectedDate,
        timeZone,
        selectedEvent,
        onEventSelect = () => {},
    } = useOutletContext<ViewContextType>();
    const [openEventDetails] = useOpenModal(CALENDAR_EVENT_DETAILS);
    const [openAddEventForm] = useOpenModal(ADD_RESCHEDULE_CALENDAR_EVENT);

    return (
        <Container>
            <CalendarWeekView
                date={selectedDate}
                calendars={calendars}
                events={events}
                timeZone={timeZone}
                selectedEvent={selectedEvent}
                onEventClick={({ triggerRef, event }) => {
                    onEventSelect(event.id as string);
                    openEventDetails({
                        triggerRef,
                        eventId: event.id,
                        calendarId: event.calendarId,
                    });
                }}
                onAvailableSpaceClick={(day, minute) => {
                    const availableCalendars = getCalendarsForAvailableSlot({
                        calendars: calendars || [],
                        day,
                        timeZone,
                        minute,
                    });
                    if (availableCalendars.length === 0) {
                        return;
                    }
                    const date = getEventStartAtFromMinutes({
                        selectedDate: day,
                        minute,
                        timeZone,
                    });
                    openAddEventForm({
                        title: <ModalTitle>Add New Event</ModalTitle>,
                        initialValues: {
                            calendar: availableCalendars[0],
                            startAt: date.toISOString(),
                        },
                        availableCalendars,
                    });
                }}
            />
        </Container>
    );
};

export default CalendarViewWeek;
